module.exports = __webpack_public_path__ + "static/media/IphoneEnglish.3e8b2bc2.png";